export const getTextKeyEntry = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'INGRESÁ TU CLAVE PERSONAL:'
    default:
      return 'INGRESA TU CLAVE PERSONAL:'
  }
}
export const getTextLoseKey = (locale) => {
  switch (locale) {
    case "es-AR":
      return '¿No encontrás las claves?'
    default:
      return '¿No encuentras las claves?'
  }
}
export const getTextForPointDescription = (locale) => {
  switch (locale) {
    case "es-PR":
      return "Los puntos son un regalo que te damos por comprar tus productos Nosotras e interactuar con nuestro sitio web. Los puntos de tus productos los encuentras en el respaldo o lateral de los empaques. Cuando quieras participar en nuestros concursos deberás tener acumulado el valor en puntos que necesitas."
    case "es-AR":
      return "Los puntos son un regalo que te damos por comprar tus productos Nosotras e interactuar con nuestro sitio web. Los puntos de tus productos los encontrás en el respaldo o lateral de los empaques. Cuando querás canjear un premio virtual, físico o participar en nuestros concursos deberás tener acumulado el valor en puntos que necesitás."
    case "es-CL":
      return "Los puntos son un regalo que te damos por comprar tus productos Nosotras e interactuar con nuestro sitio web. Los puntos de tus productos los encuentras en el respaldo o lateral de los empaques. Cuando quieras canjear un premio virtual, físico o participar en nuestros concursos deberás tener acumulado el valor en puntos que necesitas."
    default:
      return "Los puntos son un regalo que te damos por comprar tus productos Nosotras e interactuar con nuestro sitio web. Los puntos de tus productos los encuentras en el respaldo o lateral de los empaques. Cuando quieras redimir un premio virtual, físico o participar en nuestros concursos deberás tener acumulado el valor en puntos que necesitas."
  }
}
export const getTextButtonLearnMore = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Aprendé más'
    default:
      return 'Aprende más'
  }
}
export const getTitleAccumulatePoints = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Podés acumular los puntos de dos maneras'
    default:
      return 'Puedes acumular puntos de dos maneras'
  }
}
export const getTextAccumulatePoints = (locale) => {
  switch (locale) {
    case "es-AR":
      return "Ingresando las claves personales que encontrás en tus productos. Solo debés escribirla en el espacio de “ingresá tu clave personal” y en tu banco se reflejarán los puntos."
    default:
      return "Ingresando las claves personales que encuentras en tus productos. Solo debes escribirla en el espacio de “ingresa tu clave personal” y en tu banco se reflejarán los puntos."
  }
}
export const getTextAccumulatePointsPartTwo = (locale) => {
  switch (locale) {
    case "es-AR":
      return "En el empaque podés ver cuántos puntos te dará cada clave. Para canjear estos puntos"
    case "es-CL":
      return "En el empaque puedes ver cuántos puntos te dará cada clave."
    default:
      return "En el empaque puedes ver cuántos puntos te dará cada clave. Para redimir estos puntos"
  }
}
export const getTextAccumulatePointsPartThree = (locale) => {
  switch (locale) {
    case "es-AR":
      return "La marca te regalará puntos por interactuar en NosotrasOnline: escribir contenidos de nuestro Magazín, registrar tu primera clave, por tu bienvenida, por tu aniversario con la marca y más."
    case "es-CL":
      return "La marca te regalará puntos por interactuar en NosotrasOnline: registrar tu primera clave, por tu bienvenida, por tu aniversario con la marca y más."  
    default:
      return "La marca te regalará puntos por interactuar en NosotrasOnline: escribir contenidos de nuestro Magazín, registrar tu primera clave, por tu bienvenida, por tu aniversario con la marca y más."
  }
}
export const getTextAccumulatePointsPartFour = (locale) => {
  switch (locale) {
    case "es-AR":
      return "Cuando canjeés estos puntos,"
    default:
      return "Cuando redimas estos puntos"
  }
}
export const getTextAccumulatePointsPartFive = (locale) => {
  switch (locale) {
    case "es-AR":
      return "no debés presentar empaques de productos."
    default:
      return "no debes presentar empaques de productos."
  }
}
export const getTextButtonKnowMore = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Conocé más'
    default:
      return 'Conoce más'
  }
}
export const getTitlePointsFor = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Obtenés puntos por…'
    default:
      return 'Obtienes puntos por...'
  }
}
export const getTextPointsForPostContent = (locale) => {
  switch (locale) {
    case "es-AR":
      return "Serás la escritora de nuestro Magazín y por cada artículo publicado, Nosotras te regalará 20 puntos. Podrás escribir muchos para ser una súper escritora, pero solo los primeros 12 publicados en el año, te darán puntos."
    case "es-EC":
      return "Serás la escritora de nuestro Magazín y por cada artículo publicado, Nosotras te regalará 30 puntos. Podrás escribir muchos para ser una súper escritora, pero solo los primeros 12 publicados en el año, te darán puntos"
      default:
      return "Serás la escritora de nuestro Magazín y por cada artículo publicado, Nosotras te regalará 20 puntos. Podrás escribir muchos para ser una súper escritora, pero solo los primeros 12 publicados en el año, te darán puntos"
  }
}
export const getTextPointsForRegisterKeys = (locale) => {
  switch (locale) {
    case "es-AR":
      return "Cuando registrás tu primera clave personal en el nuevo NosotrasOnline, además de los puntos que te da tu clave, te regalamos 10 puntos para que tengás más opciones para canjear."
    case "es-CL":
        return "Cuando registras tu primera clave personal en el nuevo NosotrasOnline, además de los puntos que te da tu clave, te regalamos 10 puntos para que tengas más opciones para canjear."
     default:
      return "Cuando registras tu primera clave personal en el nuevo NosotrasOnline, además de los puntos que te da tu clave, te regalamos 10 puntos para que tengas más opciones para redimir."
  }
}
export const getTextPointsForYourWelcome = (locale) => {
  switch (locale) {
    case "es-AR":
      return "En este nuevo sitio todas son bienvenidas. Si ya estabas registrada o estás registrándote por primera vez, te regalaremos 10 puntos de bienvenida."
     default:
      return "En este nuevo sitio todas son bienvenidas. Si ya estabas registrada o estás registrándote por primera vez te regalaremos 10 puntos de bienvenida."
  }
}
export const getTextPointsForYourAnniversary = (locale) => {
  switch (locale) {
    case "es-AR":
      return "Cada año que cumples junto a Nosotras nos llena de emoción, por eso, te regalamos 10 puntos para que los disfrutés en nuestro mundo. Para recibir este beneficio, tendrás que haber interactuado con nuestro sitio web el último año."
     default:
      return "Cada año que cumples junto a Nosotras nos llena de emoción, por eso, te regalamos 10 puntos para que los disfrutes en nuestro mundo, para recibir este beneficio tendrás que haber interactuado con nuestro sitio web el último año"
  }
}
export const getTextButtonYouHaveProblems = (locale) => {
  switch (locale) {
    case "es-AR":
      return '¿Tenés problemas?'
    default:
      return '¿Tienes problemas?'
  }
}
export const getTextEnjoyYourPointsPartOne = (locale) => {
  switch (locale) {
    case "es-AR":
      return "Conseguí todo lo que querés, en NosotrasOnline tenemos muchas sorpresas para vos. Canjeá premios físicos, virtuales y participá en actividades cuando querás."
    case "es-PE":
      return "Consigue todo lo que quieres en NosotrasOnline."
    case "es-PY":
      return "Conseguí todo lo que quieres, en NosotrasOnline tenemos muchas sorpresas para vos. ¡Redime tus puntos y participa en nuestros concursos para ganar increíbles premios!"
    case "es-UY":
      return "Conseguí todo lo que quieres, en NosotrasOnline tenemos muchas sorpresas para vos."
    case "es-PR":
      return "Consigue todo lo que quieres, en NosotrasOnline tenemos muchas sorpresas para ti. Participa en actividades cuando quieras."
    case "es-CL":
      return "Consigue todo lo que quieres, en NosotrasOnline tenemos muchas sorpresas para ti. Canjea premios físicos, virtuales y participa en actividades cuando quieras."
    default:
      return "Consigue todo lo que quieres, en NosotrasOnline tenemos muchas sorpresas para ti. Redime premios físicos, virtuales y participa en actividades cuando quieras."
  }
}
export const getTextEnjoyYourPointsPartTwo = (locale) => {
  switch (locale) {
    case "es-AR":
      return "¡Elegí en qué preferís gastarlos!"
    case "es-PE":
      return "Próximamente te daremos más detalles sobre el canje de puntos."
    case "es-PY":
      return ""
    case "es-PR":
      return ""
    default:
      return "¡Elige en qué prefieres gastarlos!"
  }
}
export const getTextButtonRedeemItNow = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Canjealos ya'
    case "es-CL":
      return 'Canjéalos ya'
    default:
      return 'Redímelos ya'
  }
}
export const getTextOneRedeemYourPoints = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Comprá productos Nosotras, interactuá en NosotrasOnline y acumulá muchos puntos.'
    default:
      return 'Compra productos Nosotras, interactúa en NosotrasOnline y acumula muchos puntos.'
  }
}
export const getTextTwoRedeemYourPoints = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Ingresá las claves personales de tus productos en la parte superior.'
    default:
      return 'Ingresa las claves personales de tus productos en la parte superior.'
  }
}
export const getTextThreeRedeemYourPoints = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'En tu perfil podrás ver los puntos que tenés acumulados'
    default:
      return 'En tu perfil podrás ver los puntos que tienes acumulados.'
  }
}
export const getTextFourRedeemYourPoints = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Ingresá a ¿qué puedo ganar? y canjealos en todo lo que querás.'
      case "es-PE":
        return 'Próximamente te daremos más detalles sobre el canje de puntos.'
        case "es-PR":
        return 'Participa en todas las actividades que tenemos para ti.'
        case "es-CL":
          return 'Ingresa a ¿qué puedo ganar? y canjéalos en todo lo que quieras.'
    default:
      return 'Ingresa a ¿qué puedo ganar? y redímelos en todo lo que quieras.'
  }
}
export const getTextButtonLearnHow = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Aprendé cómo'
    default:
      return 'Aprende cómo'
  }
}
export const getTextWhenPointsExpire = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Los puntos que acumulaste por ingresar claves personales e interactuar en NosotrasOnline, se vencen cada año, eso quiere decir, que a partir del mes que los obtuviste tenés un año para canjearlos.'
    case "es-CL":
      return 'Los puntos que acumulaste por ingresar claves personales e interactuar en NosotrasOnline, se vencen cada año, eso quiere decir, que a partir del mes que los obtuviste tienes un año para canjearlos.'
    default:
      return 'Los puntos que acumulaste por ingresar claves personales e interactuar en NosotrasOnline, se vencen cada año, eso quiere decir, que a partir del mes que los obtuviste tienes un año para redimirlos.'
  }
}
export const getTextWhenPointsExpireExample = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'En febrero de 2020 ingreso una clave que contiene 25 puntos, estos puntos vencerán en febrero del 2021.'
    default:
      return 'En febrero de 2020 ingreso una clave que contiene 25 puntos, estos puntos vencerán en febrero del 2021.'
  }
}
export const getTextWhatCanIWin = (locale) => {
  switch (locale) {
    case "es-AR":
      return '¡Tenemos muchos premios en nuestro catálogo! Podés encontrar premios físicos, virtuales y participar en todas las actividades que tenemos para ti:'
      case "es-PE":
        return '¡Próximamente te contaremos todos los premios disponibles para ti!'
        case "es-PR":
        return 'Puedes participar en todas las actividades que tenemos para ti:'
    default:
      return '¡Tenemos muchos premios en nuestro catálogo! Puedes encontrar premios físicos, virtuales y participar en todas las actividades que tenemos para ti:'
  }
}
export const getTitleHowEnterPassword = (locale) => {
  switch (locale) {
    case "es-AR":
      return '¿Cómo ingreso claves?'
    default:
      return '¿Cómo ingreso las claves?'
  }
}
export const getTextOneHowEnterPasswords = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Registrate o iniciá sesión en NosotrasOnline'
      case "es-UY":
      return 'Registrate o inicia sesión en NosotrasOnline.'
      case "es-PY":
      return 'Registrate o inicia sesión en NosotrasOnline.'      
    default:
      return 'Regístrate o inicia sesión en NosotrasOnline.'
  }
}
export const getTextTwoHowEnterPasswords = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Ingresá la clave personal que viene al respaldo o laterales de tus productos Nosotras.'
      case "es-UY":
      return 'Ingresá la clave personal que viene al respaldo o laterales de tus productos Nosotras.'
      case "es-PY":
      return 'Ingresá la clave personal que viene al respaldo o laterales de tus productos Nosotras.'      
    default:
      return 'Ingresa la clave personal que viene al respaldo o laterales de tus productos Nosotras.'
  }
}
export const getTextThreeHowEnterPasswords = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Al ingresar la clave personal no debés utilizar espacios, puntos o guiones.'            
    default:
      return 'Al ingresar la clave  personal no debes utilizar espacios, puntos o guiones.'
  }
}
export const getTextReminderCard = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Recordá que debés guardar todos los empaques que ingresés, así, cerraremos correctamente el ciclo de nuestros empaques y ayudaremos a cuidar el planeta.'            
    default:
      return 'Recuerda que debes guardar todos los empaques que ingreses, así, cerraremos correctamente el ciclo de nuestros empaques y ayudaremos a cuidar el planeta.'
  }
}
export const getTextButtonContactUs = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Contactanos'
    default:
      return 'Contáctanos'
  }
}
export const getTextOneRedeemInfo = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Debés estar registrada en NosotrasOnline. Asegurate de tener en tu banco los puntos necesarios para canjear el premio, sean puntos ingresados por las claves personales de tus productos Nosotras o puntos que hayas ganado con las actividades de la marca.'
    case "es-EC":
      return 'Selecciona el premio que quieres y redime los puntos que necesitas. Si no te alcanzan, ingresa más claves personales o interactúa en NosotrasOnline hasta que llegues al valor necesario. Recuerda que los puntos de empaques que ingreses deberás entregarlos para poder realizar tu canje ¡No los botes! Si ya no cuentas con los empaques de puntos ingresados procura utilizarlos en juegos y dinámicas de NosotrasOnline ya que sin ellos no podremos entregarte tus premios de la estore.'
      case "es-CL":
        return 'Asegúrate de tener en tu banco los puntos necesarios para canjear el premio, sean puntos ingresados por las claves personales de tus productos Nosotras o puntos que hayas ganado con las actividades de la marca.'
    default:
      return 'Selecciona el premio que quieres y redime los puntos que necesitas. Si no te alcanzan, ingresa más claves personales o interactúa en NosotrasOnline hasta que llegues al valor necesario.'
  }
}
export const getTextTwoRedeemInfo = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Seleccioná el premio que querés y canjeá los puntos que necesitás. Si no te alcanzan, ingresá más claves personales o interactuá en NosotrasOnline hasta que llegués al valor necesario.'
    case "es-EC":
      return 'Llena el formulario con tus datos personales, asegúrate que estén correctos porque con esta información enviaremos tu premio. Muchos de los problemas en la entrega es datos incorrectos o incompletos, revisa que tu información sea la correcta y trata de dar el mayor detalle en tu dirección para que podamos hacerte llegar tu premio'
    case "es-CL":
      return 'Selecciona el premio que quieres y canjea los puntos que necesitas. Si no te alcanzan, ingresa más claves personales o interactúa en NosotrasOnline hasta que llegues al valor necesario.'
    default:
      return 'Llena el formulario con tus datos personales, asegúrate que estén correctos porque con esta información enviaremos tu premio.'
  }
}
export const getTextFourRedeemInfo = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Los premios están sujetos a disponibilidad, nuestra asesora te dirá si lo están o no al momento de comunicarte.'
    case "es-CL":
      return 'Recuerda guardar tu formulario de canje y estar atenta a las llamadas de nuestro proveedor logístico para coordinar la entrega de tu premio.'
    case "es-EC":
      return 'Al momento de la entrega de tu canje recuerda entregar los empaques de producto redimidos, nuestro proveedor logístico se encargará de verificar la cantidad de puntos entregados para hacer tu canje. RECUERDA si no entregas los empaques necesarios no te entregaremos tu premio. Si existe entrega de tus empaques y luego en auditoria validamos que no se entregaron la cantidad de empaques correspondientes a los puntos redimidos, existirá una penalización en la que se negarán los canjes y la participación en actividades de la marca a la usuaria por una duración de 1 año calendario.'
    default:
      return 'Cuando hayamos verificado tus empaques, recibirás el premio en la puerta de tu casa.'
  }
}
export const getTextOneContests = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Seleccioná la actividad en la que querés participar.'
    case "es-CL":
      return 'Selecciona la actividad en la que quieres participar.'
    default:
      return 'Selecciona la actividad en la que quieres participar. Inicia sesión y redime los puntos que necesitas.'
  }
}
export const getTextTwoContests = (locale) => {
  switch (locale) {
    case "es-AR":
      return 'Iniciá sesión y canjeá los puntos que necesités.'
    case "es-CL":
        return 'Inicia sesión y canjea los puntos que necesites.'
    default:
      return 'Debes guardar los empaques de las claves personales que ingresaste para participar, en caso de ser una ganadora debes entregarlos. Nosotras se pondrá en contacto contigo para organizar este envío. Por los puntos que utilices que son regalo de la marca no debes presentar empaques.'
  }
}
export const getTextThreeContests = (locale) => {
  switch (locale) {
    case "es-AR":
    case "es-CL":
      return 'Al momento de analizar el top de ganadoras, Nosotras nos encargaremos de comunicarnos contigo vía mail para organizar el envío de tu premio.'
    default:
      return 'Cuando verifiquemos tus empaques, recibirás el premio en tu casa.'
  }
}
export const getTextFourContests = (locale) => {
  switch (locale) {
    case "es-AR":
      return ''
    default:
      return 'Cuando hayamos verificado tus empaques, recibirás el premio en la puerta de tu casa.'
  }
}